import { render, staticRenderFns } from "./SaveAllItemDialog.vue?vue&type=template&id=2f6bf040"
import script from "./SaveAllItemDialog.vue?vue&type=script&lang=js"
export * from "./SaveAllItemDialog.vue?vue&type=script&lang=js"
import style0 from "./SaveAllItemDialog.vue?vue&type=style&index=0&id=2f6bf040&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports